import { z } from 'zod';
/** Langues que les notifications et interfaces shipment savent produire. */
export const supportedLanguageSchema = z.enum(['fr', 'nl', 'en', 'de']);
/** Les flux financiers shipment sont exclusivement libellés en euros. */
export const currencyCodeSchema = z.preprocess((value) => (typeof value === 'string' ? value.trim().toUpperCase() : value), z.literal('EUR'));
/** Le standard est payé immédiatement ; le lourd passe d’abord par un devis. */
export const shipmentBusinessModelSchema = z.enum(['immediate_payment', 'quote_based']);
/** Transporteur responsable avant la convergence logistique chez BeFret. */
export const transportProviderSchema = z.enum(['dpd', 'specialist_partner']);
/**
 * Catalogue commun des états techniques d’une étape. Chaque workflow en extrait
 * uniquement les valeurs qu’il sait produire, sans redéfinir les libellés partagés.
 */
export const processStepStatusSchema = z.enum([
    'pending',
    'in_progress',
    'success',
    'completed',
    'failed',
    'retrying',
    'skipped',
]);
